export const DEBOUNCE_SWIFT = 100
export const DEBOUNCE_DEFAULT = 300
export const DEBOUNCE_SLOW = 500
export const DEBOUNCE_SLOWER = 800
export const DEBOUNCE_EXTRA_SLOW = 1200
